'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _DebugTool = require('../DebugTool');

var _DebugTool2 = _interopRequireDefault(_DebugTool);

var _debugDocumentModeConstants = require('./debugDocumentModeConstants');

require('./DocumentModeDebugTool.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Constants
// Lib
var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
    return {
        debugDocumentMode: function debugDocumentMode(enabled) {
            if (!enabled) return;

            // FIXME should instead use measurements (elementSizeManagerDecorator has been deleted)
            // dispatch(calculateDocumentMode({
            //     elementSizes: ownProps.getElementSizes(),
            // }));
        }
    };
};

// Styles


// Components


var DocumentModeDebugTool = function DocumentModeDebugTool(_ref) {
    var debugDocumentMode = _ref.debugDocumentMode;
    return _react2.default.createElement(
        'div',
        { className: 'DocumentModeDebugTool' },
        _react2.default.createElement(
            _DebugTool2.default,
            { toolName: _debugDocumentModeConstants.DOC_MODE_DEBUG_TOOL_NAME, onClickFn: debugDocumentMode },
            'DM'
        )
    );
};

DocumentModeDebugTool.propTypes = {
    docModeDebugEnabled: _propTypes2.default.bool,
    toggleDocumentModeDebug: _propTypes2.default.func,
    debugDocumentMode: _propTypes2.default.func
};

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(DocumentModeDebugTool);


//////////////////
// WEBPACK FOOTER
// ./src/client/debug/documentMode/DocumentModeDebugTool.js
// module id = 1944
// module chunks = 0